module.exports = __webpack_public_path__ + "media/images/ui__textCross-0020418209e7de4e12dfc911aeb5f898.png";